// src/ui/etiquetas.js
// Gera etiquetas de codigo de barras (Code128) das chaves para impressao em folha A4 adesiva.
import JsBarcode from 'jsbarcode';
import { el } from '../lib/dom.js';
import { supabase } from '../config/supabaseClient.js';
import { toast } from '../lib/toast.js';

const SVGNS = 'http://www.w3.org/2000/svg';

export async function imprimirEtiquetasChaves() {
  const { data, error } = await supabase
    .from('chave')
    .select('numero, descricao, status')
    .order('numero', { ascending: true });
  if (error) { toast('Nao foi possivel carregar as chaves para etiquetar.', 'erro'); return; }
  const chaves = (data || []).filter((c) => c.status !== 'INATIVO' && c.numero != null);
  if (!chaves.length) { toast('Nenhuma chave ativa para etiquetar.', 'info'); return; }

  const grid = el('div', { class: 'etq-grid' });
  for (const c of chaves) {
    const svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('class', 'etq-bc');
    try {
      JsBarcode(svg, String(c.numero), { format: 'CODE128', displayValue: true, fontSize: 16, textMargin: 1, height: 42, width: 1.7, margin: 2 });
    } catch (e) { /* valor invalido: pula o codigo, mantem o rotulo */ }
    grid.append(el('div', { class: 'etq' }, [
      el('div', { class: 'etq__setor', text: c.descricao || '' }),
      svg,
    ]));
  }

  function fechar() { overlay.remove(); window.removeEventListener('afterprint', fechar); }
  const overlay = el('div', { class: 'etq-overlay' }, [
    el('div', { class: 'etq-bar' }, [
      el('span', { class: 'etq-bar__tit', text: `Etiquetas de chaves (${chaves.length})` }),
      el('span', { class: 'etq-bar__dica', text: 'Confira e clique em Imprimir. Folha A4 adesiva (3 colunas).' }),
      el('button', { class: 'btn btn--primario', onClick: () => window.print() }, [el('i', { class: 'ph ph-printer' }), ' Imprimir']),
      el('button', { class: 'btn', onClick: fechar }, [el('i', { class: 'ph ph-x' }), ' Fechar']),
    ]),
    el('div', { class: 'etq-scroll' }, [el('div', { class: 'etq-folha' }, [grid])]),
  ]);
  window.addEventListener('afterprint', fechar);
  document.body.append(overlay);
}